/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VesselAdvancedRegister
 */
export interface VesselAdvancedRegister {
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    registerPort?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    registerExpiryDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    registeredOwner?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    registeredOwnerCountryOfDomicile?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    registeredOwnerShare?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    registeredOwnerEffectiveDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    registeredOwnerCity?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    beneficialOwner?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    beneficialOwnerCountryOfControl?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    beneficialOwnerCountryOfDomicile?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    beneficialOwnerCountryOfRegistration?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    beneficialOwnerEffectiveDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    beneficialOwnerCity?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    shipManager?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    shipManagerCountryOfControl?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    shipManagerCountryOfDomicile?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    shipManagerCountryOfRegistration?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    shipManagerEffectiveDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    shipManagerCity?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    ismManager?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    ismManagerCountryOfControl?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    ismManagerCountryOfDomicile?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    ismManagerCountryOfRegistration?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    ismManagerEffectiveDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    ismManagerCity?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    classificationSociety?: any | null;
    /**
     * 
     * @type {any}
     * @memberof VesselAdvancedRegister
     */
    classificationSocietyEffectiveDate?: any | null;
}

/**
 * Check if a given object implements the VesselAdvancedRegister interface.
 */
export function instanceOfVesselAdvancedRegister(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VesselAdvancedRegisterFromJSON(json: any): VesselAdvancedRegister {
    return VesselAdvancedRegisterFromJSONTyped(json, false);
}

export function VesselAdvancedRegisterFromJSONTyped(json: any, ignoreDiscriminator: boolean): VesselAdvancedRegister {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'registerPort': !exists(json, 'register_port') ? undefined : json['register_port'],
        'registerExpiryDate': !exists(json, 'register_expiry_date') ? undefined : json['register_expiry_date'],
        'registeredOwner': !exists(json, 'registered_owner') ? undefined : json['registered_owner'],
        'registeredOwnerCountryOfDomicile': !exists(json, 'registered_owner_country_of_domicile') ? undefined : json['registered_owner_country_of_domicile'],
        'registeredOwnerShare': !exists(json, 'registered_owner_share') ? undefined : json['registered_owner_share'],
        'registeredOwnerEffectiveDate': !exists(json, 'registered_owner_effective_date') ? undefined : json['registered_owner_effective_date'],
        'registeredOwnerCity': !exists(json, 'registered_owner_city') ? undefined : json['registered_owner_city'],
        'beneficialOwner': !exists(json, 'beneficial_owner') ? undefined : json['beneficial_owner'],
        'beneficialOwnerCountryOfControl': !exists(json, 'beneficial_owner_country_of_control') ? undefined : json['beneficial_owner_country_of_control'],
        'beneficialOwnerCountryOfDomicile': !exists(json, 'beneficial_owner_country_of_domicile') ? undefined : json['beneficial_owner_country_of_domicile'],
        'beneficialOwnerCountryOfRegistration': !exists(json, 'beneficial_owner_country_of_registration') ? undefined : json['beneficial_owner_country_of_registration'],
        'beneficialOwnerEffectiveDate': !exists(json, 'beneficial_owner_effective_date') ? undefined : json['beneficial_owner_effective_date'],
        'beneficialOwnerCity': !exists(json, 'beneficial_owner_city') ? undefined : json['beneficial_owner_city'],
        'shipManager': !exists(json, 'ship_manager') ? undefined : json['ship_manager'],
        'shipManagerCountryOfControl': !exists(json, 'ship_manager_country_of_control') ? undefined : json['ship_manager_country_of_control'],
        'shipManagerCountryOfDomicile': !exists(json, 'ship_manager_country_of_domicile') ? undefined : json['ship_manager_country_of_domicile'],
        'shipManagerCountryOfRegistration': !exists(json, 'ship_manager_country_of_registration') ? undefined : json['ship_manager_country_of_registration'],
        'shipManagerEffectiveDate': !exists(json, 'ship_manager_effective_date') ? undefined : json['ship_manager_effective_date'],
        'shipManagerCity': !exists(json, 'ship_manager_city') ? undefined : json['ship_manager_city'],
        'ismManager': !exists(json, 'ism_manager') ? undefined : json['ism_manager'],
        'ismManagerCountryOfControl': !exists(json, 'ism_manager_country_of_control') ? undefined : json['ism_manager_country_of_control'],
        'ismManagerCountryOfDomicile': !exists(json, 'ism_manager_country_of_domicile') ? undefined : json['ism_manager_country_of_domicile'],
        'ismManagerCountryOfRegistration': !exists(json, 'ism_manager_country_of_registration') ? undefined : json['ism_manager_country_of_registration'],
        'ismManagerEffectiveDate': !exists(json, 'ism_manager_effective_date') ? undefined : json['ism_manager_effective_date'],
        'ismManagerCity': !exists(json, 'ism_manager_city') ? undefined : json['ism_manager_city'],
        'classificationSociety': !exists(json, 'classification_society') ? undefined : json['classification_society'],
        'classificationSocietyEffectiveDate': !exists(json, 'classification_society_effective_date') ? undefined : json['classification_society_effective_date'],
    };
}

export function VesselAdvancedRegisterToJSON(value?: VesselAdvancedRegister | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'register_port': value.registerPort,
        'register_expiry_date': value.registerExpiryDate,
        'registered_owner': value.registeredOwner,
        'registered_owner_country_of_domicile': value.registeredOwnerCountryOfDomicile,
        'registered_owner_share': value.registeredOwnerShare,
        'registered_owner_effective_date': value.registeredOwnerEffectiveDate,
        'registered_owner_city': value.registeredOwnerCity,
        'beneficial_owner': value.beneficialOwner,
        'beneficial_owner_country_of_control': value.beneficialOwnerCountryOfControl,
        'beneficial_owner_country_of_domicile': value.beneficialOwnerCountryOfDomicile,
        'beneficial_owner_country_of_registration': value.beneficialOwnerCountryOfRegistration,
        'beneficial_owner_effective_date': value.beneficialOwnerEffectiveDate,
        'beneficial_owner_city': value.beneficialOwnerCity,
        'ship_manager': value.shipManager,
        'ship_manager_country_of_control': value.shipManagerCountryOfControl,
        'ship_manager_country_of_domicile': value.shipManagerCountryOfDomicile,
        'ship_manager_country_of_registration': value.shipManagerCountryOfRegistration,
        'ship_manager_effective_date': value.shipManagerEffectiveDate,
        'ship_manager_city': value.shipManagerCity,
        'ism_manager': value.ismManager,
        'ism_manager_country_of_control': value.ismManagerCountryOfControl,
        'ism_manager_country_of_domicile': value.ismManagerCountryOfDomicile,
        'ism_manager_country_of_registration': value.ismManagerCountryOfRegistration,
        'ism_manager_effective_date': value.ismManagerEffectiveDate,
        'ism_manager_city': value.ismManagerCity,
        'classification_society': value.classificationSociety,
        'classification_society_effective_date': value.classificationSocietyEffectiveDate,
    };
}

